export default "__VITE_PUBLIC_ASSET__169963e3__"